import React from 'react';

import svg from './assets/icons-16-shipping.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconShipping = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-shipping" />
);
